import { render, staticRenderFns } from "./NowPlaying.vue?vue&type=template&id=320c58fe&scoped=true&"
import script from "./NowPlaying.vue?vue&type=script&lang=js&"
export * from "./NowPlaying.vue?vue&type=script&lang=js&"
import style0 from "./NowPlaying.vue?vue&type=style&index=0&id=320c58fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c58fe",
  null
  
)

export default component.exports